import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";
import { ReactComponent as Figure1 } from "./figure-1.svg";
import { ReactComponent as Figure2 } from "./figure-2.svg";
import { ReactComponent as Figure3 } from "./figure-3.svg";
import { ReactComponent as Figure4 } from "./figure-4.svg";
import { ReactComponent as Figure5 } from "./figure-5.svg";

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 400px;
  pointer-events: none;
  max-width: 1680px;
  left: 50%;
  transform: translateX(-50%);

  display: none;
  ${mediaMin.md`
    display: block;
  `}
`;

const StyledFigure1 = styled(Figure1)`
  position: absolute;
  top: -280px;
  left: 0;
`;

const StyledFigure2 = styled(Figure2)`
  position: absolute;
  top: 240px;
  left: -80px;
`;

const StyledFigure3 = styled(Figure3)`
  position: absolute;
  top: -40px;
  left: 80px;
`;

const StyledFigure4 = styled(Figure4)`
  position: absolute;
  top: -120px;
  right: 0;
`;

const StyledFigure5 = styled(Figure5)`
  position: absolute;
  top: 240px;
  right: 0;
`;

export function Figures() {
  return (
    <Wrapper>
      <StyledFigure1 />
      <StyledFigure2 />
      <StyledFigure3 />
      <StyledFigure4 />
      <StyledFigure5 />
    </Wrapper>
  );
}
